import React from 'react'
import Button from 'react-bootstrap/lib/Button';

const TrackableButton = (props) => {
  const clickIt = e => {
    e.preventDefault()
    props.onClick(e)
    // TODO: This is erroring in the browser
    // props.trackEvent(e)
  }

  return (
    <Button
      type={ props.type }
      id={props.id || `host-wizard-page-${props.disabled ? 'disabled' : 'enabled'}-${props.page}` }
      style={ props.style }
      className={ props.className }
      data-page={props.page}
      disabled={props.disabled}
      onClick={clickIt}
    >{props.text}</Button>
  )
};

export default TrackableButton;
